import {Routes} from '@angular/router';
import {featureTranslationGuard} from './core/i18n/feature-translation.guard';
import {LayoutContainerComponent} from './layout/layout-container.component';
import {DefaultLayoutComponent} from './shared/ui/default-layout/default-layout.component';
import {Error404Component} from "./pages/extra-pages/error404/error404.component";
import {Error402Component} from "./pages/extra-pages/error402/error402.component";

export const routes: Routes = [
    {
        // redirect a root path to dashboard - for non-authorized user this will lead to redirection to login
        path: '',
        redirectTo: '/page/dashboard',
        pathMatch: 'full'
    },
    {
        // main tree
        // guarding solved at subsidiary level
        path: 'page',
        canActivateChild: [featureTranslationGuard],
        component: LayoutContainerComponent,
        loadChildren: () => import('./apps/apps.routes').then(r => r.APP_ROUTES)
    },
    {
        // free for UNAUTHENTICATED user
        path: 'auth',
        component: DefaultLayoutComponent,
        loadChildren: () => import('./auth/auth.routes').then(r => r.AUTH_ROUTES)
    },
    {
        // 404 page
        path: '404',
        component: DefaultLayoutComponent,
        children: [
            {
                path: '', // The empty path makes this the default child
                component: Error404Component // The component to display inside the layout
            }
        ]
    },
    {
        // 402 page
        path: '402',
        component: DefaultLayoutComponent,
        children: [
            {
                path: '', // The empty path makes this the default child
                component: Error402Component // The component to display inside the layout
            }
        ]
    },
    {
        // default to 404 for unrecognized paths
        path: '**',
        component: DefaultLayoutComponent,
        children: [
            {
                path: '', // The empty path makes this the default child
                component: Error404Component // The component to display inside the layout
            }
        ]
    }
];
